export default __webpack_public_path__ + "static/media/placeholder-image-1.44395c81.jpg";